import { render, staticRenderFns } from "./news-importer-page.vue?vue&type=template&id=7b12924d&"
import script from "./news-importer-page.vue?vue&type=script&lang=js&"
export * from "./news-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports